import { createContext, useContext } from "react";

export const MinimalChromeContext = createContext(false);

export function useMinimalChrome() {
  return useContext(MinimalChromeContext);
}
